import * as api from '../../services/cmenums'

export const FETCH_CM_ENUMS = 'FETCH_CM_ENUMS';

export const fetchCMEnums = () => {
    return {
        type: FETCH_CM_ENUMS,
        payload: {
            promise: api.findCMEnums()
        }
    }
}





// WEBPACK FOOTER //
// ./src/redux/actions/cmenums.js